// Identifies this client surface for data-change echo suppression: every API write carries the id
// (see BaseQuery), the backend stamps it onto the Cosmos documents it writes, and the change-feed
// notification echoes it back so the client that caused a change can skip invalidating itself
// (see useDataChangeInvalidator).

let clientInstanceId: string = crypto.randomUUID();

export function getClientInstanceId(): string {
  return clientInstanceId;
}

/**
 * Adopts another document's client instance id. An MFE iframe adopts its parent app's id (delivered
 * with the token handoff, before the iframe's first API call) so the parent and the iframes it hosts
 * count as one client — without this, each JS realm generates its own id and a write made in one
 * realm bounces back into the other as a foreign change.
 */
export function adoptClientInstanceId(id: string): void {
  clientInstanceId = id;
}
